export default __webpack_public_path__ + "static/media/IMG_2038-opt.3911186e.jpg";